<template>
  <div class="home">
    <Banner />
    <Explores :keyData="'author'" :title="'Explore Authors'" :items="authors" />
    <Explores :keyData="'category'" :title="'Explore Categories'" :items="categories" />
    <Explores :keyData="'publisher'" :title="'Explore Publishers'" :items="publishers" />
    <Body />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Banner from '@/components/home/Banner'
import Body from '@/components/home/Body'
import Explores from '@/components/Explores'

export default {
  name: 'Home',
  components: {
    Banner,
    Body,
    Explores
  },
  computed: {
    ...mapState({
      categories: state => state.category.categories,
      authors: state => state.author.authors,
      publishers: state => state.publisher.publishers
    })
  },
  mounted () {
    this.getCategories()
    this.getAuthors()
    this.getPublishers()
  },
  methods: {
    ...mapActions({
      getCategories: 'category/fetchCategories',
      getAuthors: 'author/fetchAuthors',
      getPublishers: 'publisher/fetchPublishers'
    })
  }
}
</script>

<style scoped>
</style>
